/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';

import { TextLink } from './TextLink';
import withDynamicFontSize from './wrappers/withDynamicFontSize';

const DEFAULT_FONT_SIZE = 14;
const MAX_HEIGHT = 42;

const SecondaryNav = (props) => (
  <nav className={classnames('cmp-secondary-nav', props.className)} style={{ paddingTop: `${props.verticalOffset}px` }}>
    <ul>
      {
        props.secondaryNav.map((n, index) => {
          const linkClassName = classnames('font-footnote__STATIC', {
            'is-active': n.isActive,
            'icon-link': !n.isActive,
          });
          return (
            <li onClick={() => { if (props.isClickable) { props.selectSecondaryNav(n.value); } }} className={n.isActive ? `is-active ${props.activeBorderClassName}` : null} key={index}>
              <TextLink className={linkClassName} colorClass={n.isActive ? props.activeFontColorClassName : null}>
                {n.isActive && <div className={classnames('cmp-secondary-nav-underlying', props.underlyingNavClassName)} />}
                <FormattedMessage {...n.labelData} />
              </TextLink>
            </li>
          );
        })
      }
    </ul>
  </nav>
);
SecondaryNav.propTypes = {
  className: PropTypes.string,
  isClickable: PropTypes.bool,
  underlyingNavClassName: PropTypes.string,
  selectSecondaryNav: PropTypes.func,
  secondaryNav: PropTypes.array.isRequired,
  verticalOffset: PropTypes.number,
  activeBorderClassName: PropTypes.string,
  activeFontColorClassName: PropTypes.string,
};
SecondaryNav.defaultProps = {
  isClickable: true,
  activeBorderClassName: 'cmp-secondary-nav-active-tab',
};

const SecondaryNavWithDynaMicFontSize = withDynamicFontSize(SecondaryNav, DEFAULT_FONT_SIZE, MAX_HEIGHT);

export const GroupThemedSecondaryNav = (props) => (
  <SecondaryNavWithDynaMicFontSize className="theme-group base background" underlyingNavClassName="theme-group highlight background" {...props} />
);

export const ProfileThemedSecondaryNav = (props) => (
  <SecondaryNavWithDynaMicFontSize className="bkgd-color-profile" underlyingNavClassName="bkgd-color-profile-highlight" {...props} />
);
